import { VerdictNotSentError } from "@/predictions/verdictError";

/** Reader-study per-stone confidence (ENG-262), stored as attributes.reader_confidence. */
export const READER_CONFIDENCE_KEY = "reader_confidence";
export const READER_CONFIDENCE_LABEL = "Confidence this is a stone (1–100)";
export const READER_CONFIDENCE_HINT = "Enter your confidence (1–100)";
/** Scale anchors as worded in the study protocol. */
export const READER_CONFIDENCE_ANCHORS = "1 = definitely not a stone, 100 = definitely a stone";

/**
 * The rating as an integer 1..100, or null for anything else. Input such as
 * "4.5", "1e2", "1000" or "-4" is rejected, never coerced: a silent 10x slip
 * could not be caught afterwards.
 */
export function parseReaderConfidence(value: unknown): number | null {
  const text = typeof value === "number" ? String(value) : typeof value === "string" ? value : "";
  if (!/^\d{1,3}$/.test(text.trim())) return null;
  const parsed = Number(text.trim());
  return parsed >= 1 && parsed <= 100 ? parsed : null;
}

/** Accept's rating in the study arm; refuses before any request when it is missing. */
export function requireAcceptReaderConfidence(value: unknown): number {
  const parsed = parseReaderConfidence(value);
  if (parsed == null)
    throw new VerdictNotSentError("confidence-missing", "Reader confidence is missing");
  return parsed;
}

/**
 * Attributes of the annotation an AI Accept saves. The rating rides inside
 * annotation.attributes: the verdict body itself forbids extra keys.
 */
export function acceptedPredictionAttributes(
  preview: { condition: string; sourceSegmentIndex: number },
  readerConfidence: number | null,
): Record<string, string | number> {
  return {
    ai_prediction_condition: preview.condition,
    ai_prediction_source_segment_index: preview.sourceSegmentIndex,
    ai_prediction_review: "accepted",
    ...(readerConfidence != null ? { [READER_CONFIDENCE_KEY]: readerConfidence } : {}),
  };
}
